var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4018_3823)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4018_3823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.738517 12.5L4.33852 3.5H11.6615L15.2615 12.5H0.738517Z",
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5H12.5V6H3.5V5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 12,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.5L5.5 12.5",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.5L10.5 12.5",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4018_3823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4018_3823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimian);
export default __webpack_public_path__ + "static/media/dimian.68c1935c5c36c460cdb5016974da3342.svg";
export { ForwardRef as ReactComponent };